import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

// ...

const ImageModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  images: string[];
}> = ({ isOpen, onClose, images }) => {
  if (!isOpen) {
    return null;
  }

  return (
    // <div className="fixed top-0 left-0 w-full h-full flex items-center justify-start bg-black bg-opacity z-50">
    <div className="bg-white p-4 rounded-lg">
      {/* <button onClick={onClose}>Close</button> */}
      <Carousel>
        {images.map((image, index) => (
          <div key={index}>
            <img
              src={ipfsGatewayImage(image)}
              alt=""
              className="w-full h-auto max-h-[60%] object-cover"
            />
          </div>
        ))}
      </Carousel>
    </div>
    // </div>
  );
};

export default ImageModal;
